














































































import Vue from 'vue';
import { ICustomSelectOption, IVoucherAssignmentCustomerData } from '../../../common/interfaces/shared.interface';
import { IAssignableVoucherInfo } from '../../../common/interfaces/vouchers.interface';
import CustomSelect from '../selects/CustomSelect.vue';
import CustomButton from '../../layout/buttons/CustomButton.vue';
import VoucherAssignmentFailedMessage from './VoucherAssignmentFailedMessage.vue';
import FormatHelper from '@/helpers/FormatHelper';

interface ICustomerBasedVoucherAssignmentComponent {
  selectedVoucher?: IAssignableVoucherInfo;
}

export default Vue.extend({
  name: `CustomerBasedVoucherAssignment`,
  components: { CustomButton, CustomSelect, VoucherAssignmentFailedMessage },
  data(): ICustomerBasedVoucherAssignmentComponent {
    return {
      selectedVoucher: undefined,
    };
  },
  computed: {
    formattedSelectedVoucherValue(): string {
      if(!this.selectedVoucher?.voucherType) {
        return `-`;
      }
      return FormatHelper.formatVoucherValue(this.selectedVoucher.value, this.selectedVoucher.voucherType);
    },
    selectOptions(): ICustomSelectOption<string>[] {
      const defaultOption = {
        optionText: this.$t(`header:vouchers.pleaseSelect`),
        optionValue: ``,
      };

      const options = this.vouchers
        .filter((voucher, index, self) => index === self.findIndex(el => el.value === voucher.value))
        .map(voucher => {
          const firstCode = this.vouchers.find(singleVoucher => singleVoucher.value === voucher.value)?.voucherCode ?? ``;
          const amount = this.vouchers.filter(singleVoucher => singleVoucher.value === voucher.value).length;
          return {
            optionText: `${voucher.voucherType
              ? FormatHelper.formatVoucherValue(voucher.value, voucher.voucherType)
              : ``} ${this.$t(`header:voucher`)} (${this.$t(`header:vouchers.numberAvailable`, { number: amount })})`,
            optionValue: firstCode,
          };
        });

      return [
        defaultOption,
        ...options,
      ];
    },
  },
  props: {
    customer: {
      required: true,
      type: Object as () => IVoucherAssignmentCustomerData,
    },
    showAssignmentError: {
      default: false,
      type: Boolean,
    },
    vouchers: {
      required: true,
      type: Array as () => IAssignableVoucherInfo[],
    },
  },
  methods: {
    changeSelectedVoucher(option: string): void {
      this.selectedVoucher = this.vouchers.find(voucher => voucher.voucherCode === option);
    },
  },
});
